// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media print{body>:not(.printable-bookings-container){display:none!important}}.printable-bookings-container{overflow:hidden;z-index:100000000000;background:#fff;list-style:none;padding:0;margin:0}@media screen{.printable-bookings-container{display:none}}.printable-bookings-container li{padding:16px;margin:0;border-bottom:1px dashed #888;-moz-column-break-inside:avoid;break-inside:avoid;display:block}.printable-bookings-container li::last-child{border-bottom:none}", ""]);
// Exports
module.exports = exports;
